import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Container, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import { BusyIndicator } from './BusyIndicator';
import { handleResponse } from '../utils/handlers';

import styles from './ProblemForm.module.css';

function ProblemForm(props) {

    let history = useHistory();

    const { consignmentId } = useParams();
    const [chargingNotes, setChargingNotes] = useState(history.location.state || '');
    const [busy, setBusy] = useState(false);

    var markProblem = (e) => {

        setBusy(true);

        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        fetch(`api/consignments/${consignmentId}/problem`, {
            credentials: 'include',
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                isProblem: true,
                chargingNotes: chargingNotes
            })
            })
            .then(handleResponse)
            .then(data => {
                setBusy(false);
                history.push(`/consignment/${consignmentId}`);
            })
            .catch(error => {
                setBusy(false);
                console.log(error);
            });

    };

    return (
        <React.Fragment>
            <Container>
                <Form onSubmit={null}>
                    <FormGroup row>
                        <Label>Charging Notes</Label>
                        <Input type="textarea" value={chargingNotes} onChange={e => setChargingNotes(e.target.value)} />
                    </FormGroup>
                </Form>
            </Container>
            <Button color="primary" onClick={markProblem} block>Mark Problem</Button>
            <Button color="primary" onClick={e => history.push(`/consignment/${consignmentId}`)} block>Cancel</Button>
            <BusyIndicator isBusy={busy} />
        </React.Fragment>
        );
}

export { ProblemForm };